const DEFAULT_PACKAGE_META = {
  enableCustomerCanBookExtraHours: false,
  enableCustomerCanBookExtraDays: false,
  enableCustomerCanBookPerUnit: false,
  enableCustomerCanBookPerUnitRange: false,
  hasBackdrops: false,
  dateMode: "date_time",
  extraCategories: {},
}

function packageMetaFor({ packageMeta, packageUnitRangeMeta, eventTypeExtraCategoryMeta, packageId }) {
  if(packageMeta && packageMeta[packageId]) {
    const meta = packageMeta[packageId].attributes

    if(packageUnitRangeMeta) {
      meta.packageUnitRanges = Object.values(packageUnitRangeMeta)
        .map(r => r.attributes)
        .filter(r => r.eventTypeId == packageId )
    }

    meta.extraCategories = {}
    if(eventTypeExtraCategoryMeta) {
      Object.values(eventTypeExtraCategoryMeta)
        .filter(cat => cat.attributes.eventTypeId == packageId )
        .forEach(cat => meta.extraCategories[cat.attributes.extraCategoryId] = cat.attributes )
    }

    return meta
  }
  else {
    return DEFAULT_PACKAGE_META
  }
}

export default packageMetaFor
